﻿import {writable} from "svelte/store";
import type {IRouteInfo} from "../utils/types";

export const routeInfoStore = writable<{ [id: string]: IRouteInfo }>({});